import { ApiEntity } from 'app/api/models/api-entity.model';

export class TimeModel extends ApiEntity {
  constructor(public id: number = null,  public currentDateTime: Date = null, public showTimeProvider: boolean = false ) {
    super();
  }
}
